import { BookedEvent } from '@tebuto/api/therapists/models/BookedEvent'
import type { FullCalendarEvent, ParsedTebutoRuleEvent } from '@tebuto/functions/calendar'

export interface CalendarRuleEventFilters {
    showFreeAppointments: boolean
    showBookedAppointments: boolean
}

export function ruleEventHasBooking(details: BookedEvent | undefined): boolean {
    if (!details) {
        return false
    }
    if (details.booking) {
        return true
    }
    return details.status ? details.status !== BookedEvent.status.OPEN : false
}

export function filterCalendarRuleEvents(
    events: FullCalendarEvent<ParsedTebutoRuleEvent>[],
    filters: CalendarRuleEventFilters
): FullCalendarEvent<ParsedTebutoRuleEvent>[] {
    return events
        .filter((event) => (filters.showFreeAppointments ? true : ruleEventHasBooking(event.extendedProps.details)))
        .filter((event) => (filters.showBookedAppointments ? true : !ruleEventHasBooking(event.extendedProps.details)))
}
